






































import {Component, Emit, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter, State, Mutation} from 'vuex-class';
import {MAFUser} from '@/store/User/types';
import {User} from 'firebase'; // @ is an alias to /src
import BDropdown from 'buefy/src/components/dropdown/Dropdown.vue';
import BDropdownItem from 'buefy/src/components/dropdown/DropdownItem.vue';
import {dropdownToggle} from '@/components/Dashboard/types';

const userState = 'userState';

@Component({
     components: {BDropdown, BDropdownItem},
 })
 export default class SettingModal extends Vue {
     @Prop(String) public readonly path!: string;
     @State('self', {namespace: 'userState'}) public self: MAFUser | undefined;
     @State('currentUser') public currentUser: User | undefined;
     @Getter('getUserImgURL') public getUserImgURL: any;
     @Mutation('setSelf', {namespace: userState}) public setSelf: any;
     @Ref('coinRef') public coinRef!: dropdownToggle;

     public BASE_URL: string;

     constructor() {
         super();
         this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
     }

     @Emit('coinShow')
     public showCoins() {
         this.$router.push('/dashboard/showCoins');
     }

     @Emit('shareShow')
     public showShare() {
         this.$router.push('/dashboard/shareShow');
     }

     @Emit('faqShow')
     public faqShow() {
         this.$router.push('/dashboard/faqShow');
     }

     @Emit('profileShow')
     public profileShow() {
         this.$router.push('/dashboard/profileShow');
     }

     public async signOut() {
         await this.$auth.signOut();
         this.$router.push('/');
         await this.setSelf(undefined);
         location.reload();
     }

     public openMessages() {
         (document.getElementById('menu-btn') as HTMLInputElement).checked = false;
         this.$router.push('/dashboard/messages');
     }

     public openMeetups() {
         (document.getElementById('menu-btn') as HTMLInputElement).checked = false;
         this.$router.push('/dashboard/meetups');
     }

     public openSetting() {
         (document.getElementById('menu-btn') as HTMLInputElement).checked = false;
         this.$router.push('/dashboard/settings');
     }

     public admin() {
         this.$router.push('/admin');
     }


 }
